import {useCallback} from 'react'

import {HierarchyTableNode} from '../types'

export const useExpandCollapse = (
  getIsExpanded: (id: string) => boolean,
  toggleExpandCollapse: (id: string) => void
) => {
  const isItemExpanded = useCallback(
    (item: HierarchyTableNode) => getIsExpanded(item.id),
    [getIsExpanded]
  )
  const onItemToggled = useCallback(
    (item: HierarchyTableNode) => toggleExpandCollapse(item.id),
    [toggleExpandCollapse]
  )
  return {isItemExpanded, onItemToggled}
}
